import type { UpcomingAction } from 'store/slices/upcoming-actions/upcoming-actions.slice';
import { endpoints } from 'store/endpoints';
import type { GetUpcomingActionsParams } from 'store/slices/upcoming-actions/actions';
import { axiosInstance } from './axiosInstance';

export class UpcomingActionsService {
  static async update(payload: UpcomingAction) {
    try {
      const formData = new FormData();
      const { file, date, id } = payload;
      if (file) {
        formData.append('file', file);
      }
      formData.append('body', JSON.stringify({ date, id }));
      const response = await axiosInstance.patch<UpcomingAction>(
        endpoints['upcoming-actions'].opWithId(id),
        formData,
      );
      return response.data;
    } catch (err: any) {
      throw new Error(err);
    }
  }
  static async createNew(payload: Omit<UpcomingAction, 'id'>) {
    try {
      const response = await axiosInstance.post<UpcomingAction>(
        endpoints['upcoming-actions'].general,
        payload,
      );
      return response.data;
    } catch (err: any) {
      throw new Error(err);
    }
  }
  static async getAllUpcomingActions(params?: GetUpcomingActionsParams) {
    try {
      const response = await axiosInstance.get<Array<UpcomingAction>>(
        endpoints['upcoming-actions'].general,
        {
          params,
        },
      );
      return response.data;
    } catch (err: any) {
      throw new Error(err);
    }
  }
}
